import { BrandKitCreationModal } from 'components/BrandKitCreationModal/BrandKitCreationModal'
import { TierUpgradeModal } from 'components/TierUpgradeModal/TierUpgradeModal'

import { useTierUsageLimits } from './useTierUsageLimits'
import { useModals } from 'almanac-ui/Modal'

export const useOpenBrandKitCreationModal = ({
  onClose,
  newStack = false,
}: { onClose?: () => void; newStack?: boolean } = {}) => {
  const { openModal } = useModals()
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({ limitKey: 'brand_kits' })
  const shouldEnforceTierLimit = atLimit && nextTierPlan && currentTierPlan

  const openBrandKitModal = () => openModal(BrandKitCreationModal, { onClose }, { newStack })

  const openBrandKitCreationModal = () => {
    if (shouldEnforceTierLimit) {
      openModal(TierUpgradeModal, {
        reason: 'limit_reached',
        feature: 'Brand Styles',
        upgradeTier: nextTierPlan,
        currentTier: currentTierPlan,
        onUpgrade: openBrandKitModal,
      })
    } else {
      openBrandKitModal()
    }
  }

  return { openBrandKitCreationModal }
}
